
import React from 'react';
import CustomRegistrationForm from './CustomRegistrationForm';

const RegistrationForm = () => {
  return <CustomRegistrationForm />;
};

export default RegistrationForm;
